import { render, staticRenderFns } from "./IconBase.vue?vue&type=template&id=4ad9effb"
import script from "./IconBase.vue?vue&type=script&lang=js"
export * from "./IconBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports